import { IoLogoHtml5 } from "react-icons/io5";
import { SiExpress, SiCss3, SiHtml5, SiTailwindcss, SiJavascript, SiReact, SiNodedotjs, SiMongodb, SiSass, SiFirebase, SiSolidity, SiWeb3Dotjs, SiBootstrap, SiPython } from "react-icons/si";

const Skills = ({ lightMode }) => {
  return (
    <div className={'section ' + (lightMode ? 'light-primary' : 'dark-primary')}>
      <p className="norm-header">Skills</p>
      <div className="skills-content">
        <SiHtml5 />
        <SiCss3 />
        <SiExpress />
        <SiTailwindcss />
        <SiJavascript />
        <SiReact />
        <SiNodedotjs />
        <SiMongodb />
        <SiSass />
        <SiFirebase />
        <SiSolidity />
        <SiWeb3Dotjs />
        <SiBootstrap />
        <SiPython />
      </div>
    </div>
  )
}

export default Skills
